<template>
    <div class="animated fadeIn">
  
      
      <b-card class="card-accent-info" header="Estoque - Produtos">
        <b-card-body>
  
          <b-row>
            <b-col cols="auto" class="mr-auto">
                <b-form-group>
                    <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
              </b-form-group>
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="vine" class="mr-1 btn-brand" @click="openBatchModal()"  v-show="tableSelectable"><i class="fa fa-toggle-on"></i><span>Alterar Status</span></b-button>
                &nbsp;
                <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Novo Produto</span></b-button>
              </b-form-group>
            </b-col>
          </b-row>
              
  
        

          <b-row>
            <b-col cols="auto" >
              <b-form-group>
                  <label for="filter" style="font-size: 0.8em">Localizar</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Localizar"></b-form-input>
              </b-form-group>
            </b-col>
          
            <b-col cols="auto" >
              <b-form-group>
                  <label for="productType" style="font-size: 0.8em">Tipo de Produto</label>
                  <b-form-select id="productType"
                    v-model="filters.type"
                    :plain="true"
                    :options="typeddl"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>
          
            <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Status</label>
                  <b-form-select id="status"
                    v-model="filters.status"
                    :plain="true"
                    :options="statusddl"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>

            

            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage" style="font-size: 0.8em">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>
        

            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped
                selected-variant="primary"
                >

                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>

                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                           <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                           
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                


                <template #row-details="row">
                 
                  <table>
                        <tr width='100%'>
                          <td><i>Apelido: </i></td>
                          <td style="min-width: 100px"><b>{{ row.item.alias }}</b></td>
                          <td><i>Departamento: </i></td>
                          <td style="min-width: 100px"><b>{{ row.item.department }}</b></td>
                          <td><i>Cargo: </i></td>
                          <td style="min-width: 100px"><b>{{ row.item.jobname }}</b></td>
                          <td><i>Nascimento: </i></td>
                          <td style="min-width: 100px"><b>{{ row.item.daten }}</b></td>
                          <td width='100%'></td>
                        </tr>
                      </table>
                </template>
                
                <template v-slot:cell(avatar)="data">
                    <img :src="data.item.avatar ? data.item.avatar : 'img/noimage.png'" class="circle-img rounded-circle" />
                </template>
                
                <template v-slot:cell(st)="data">
                    <label class="switch switch-pill switch-primary">
                      <input type="checkbox" class="switch-input" :checked="data.item.st=='A'" @click="changeStatus(data.item)">
                      <span class="switch-slider"></span>
                    </label>
                    <!--
                    <c-switch class="" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" v-on:click="changeStatus2(data.item)" /> 
                    -->
                </template>
                
                <template v-slot:cell(name)="data">
                    <span class="text-brand-500">{{ data.item.ean }}</span><br>
                    <span class="text-dark font-weight-bold">{{ data.item.name }}</span><br>
                    <span class="text-primary">{{ data.item.description }}<br></span>
                </template>
                
            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>


        </b-card-body>
     </b-card>
  
     <b-modal title="Alterar Selecionados" class="modal-danger" v-model="dangerModal" @ok="changeStatusBatch" ok-variant="success"
        header-bg-variant="success"
        cancel-title="Cancelar"
     
     >
      Deseja realmente alterar o status dos usuários selecionados?
    </b-modal>
  
     <b-modal
     header-bg-variant="primary"
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Usuário"
              size="lg">
  
        <b-form @submit.stop.prevent="onSubmit">
  
        <div class="animated fadeIn">
      
          <b-card>
            <div slot="header">
              <strong>Dados do Usuário</strong>
            </div>

            <b-form-group
              description=""
              label="Id"
              label-for="id"
              :label-cols="3"
              :horizontal="true" v-show="selectedItem.id">
              <b-form-input  v-model="selectedItem.id" id="id" type="text" autocomplete="id" placeholder="Id" readonly></b-form-input>
            </b-form-group>    

              <b-form-group
              description=""
              label="Usuário"
              label-for="username"
              :label-cols="3"
              :horizontal="true">
              <b-form-input  v-model="selectedItem.username" id="username" type="text" autocomplete="name" placeholder="Nome do usuário"></b-form-input>
            </b-form-group>    

            <b-form-group
              description=""
              label="Senha"
              label-for="password"
              :label-cols="3"
              :horizontal="true" v-show="!selectedItem.id">
              <b-form-input  v-model="selectedItem.password" id="password" type="password" autocomplete="password" placeholder="Senha"></b-form-input>
            </b-form-group>    

            <b-form-group
              description=""
              label="Confirmar senha"
              label-for="password2"
              :label-cols="3"
              :horizontal="true" v-show="!selectedItem.id">
              <b-form-input  v-model="selectedItem.password2" id="password2" type="password" autocomplete="password2" placeholder="Confirmar senha"></b-form-input>
            </b-form-group>    

          </b-card>

          <b-card>
            <div slot="header">
              <strong>Dados Pessoais</strong>
            </div>

          
            
            <b-form-group
            description=""
            label="Nome"
            label-for="fullname"
            :label-cols="3"
            :horizontal="true">
            <b-form-input v-model="selectedItem.name" id="fullname" type="text" autocomplete="name" placeholder="Nome completo"></b-form-input>
          </b-form-group>
          <b-form-group
            description=""
            label="Apelido"
            label-for="alias"
            :label-cols="3"
            :horizontal="true">
            <b-form-input v-model="selectedItem.alias" id="alias" type="text" autocomplete="alias" placeholder="Apelido"></b-form-input>
          </b-form-group>
          <b-form-group
            label="Sexo"
            label-for=""
            :label-cols="3"
            :horizontal="true">
            <b-form-radio-group
              id="gender"
              name="gender">
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="gender1" name="gender" v-model="selectedItem.genderid" class="custom-control-input" value="1">
                <label class="custom-control-label" for="gender1">Masculino</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="gender2" name="gender" v-model="selectedItem.genderid" class="custom-control-input" value="2">
                <label class="custom-control-label" for="gender2">Feminino</label>
              </div>
            </b-form-radio-group>
          </b-form-group>
        
          <b-form-group
            label="Data de nascimento"
            label-for="daten"
            :label-cols="3"
            :horizontal="true">
            <b-form-input v-model="selectedItem.daten" type="date" id="daten"></b-form-input>
          </b-form-group>
          <b-form-group
            description="Por favor entre com seu e-mail"
            label="E-mail"
            label-for="email"
            :label-cols="3"
            :horizontal="true">
            <b-form-input v-model="selectedItem.email" id="email" type="email" placeholder="Entre com seu e-mail" autocomplete="email"></b-form-input>
          </b-form-group>

          <b-form-group label="Telefone" 
            description=""
            label-for="phone"
            :label-cols="3"
            :horizontal="true"
          >
            <b-input-group>
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class='fa fa-phone'></i>
                </span>
              </div>
              <masked-input
                type="tel"
                name="phone"
                class="form-control"
                v-model="selectedItem.telephone"
                :mask="['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                :guide="true"               
                >
              </masked-input>
            </b-input-group>

            <input type="checkbox" v-model="selectedItem.phonepublic" true-value=true false-value=false /> Exibir no portal

                        
          </b-form-group>

          <b-form-group label="Ramal"             
            description=""
            label-for="phoneext"
            :label-cols="3"
            :horizontal="true"
          >
            <b-input-group>
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class='fa fa-headphones'></i>
                </span>
              </div>
              <masked-input
                type="tel"
                name="phoneext"
                class="form-control"
                v-model="selectedItem.phoneext"
                :mask="[/[1-9]/, /[1-9]/, /[1-9]/, /[1-9]/, /[1-9]/]"
                :guide="true"     
                
                >
              </masked-input>
            </b-input-group>

            <input type="checkbox" v-model="selectedItem.phoneextpublic" true-value=true false-value=false /> Exibir no portal             
            

          </b-form-group>

         

          </b-card>

          <b-card>
            <div slot="header">
              <strong>Empresa</strong>
            </div>

          <b-form-group
            description=""
            label="Cargo"
            label-for="jobname"
            :label-cols="3"
            :horizontal="true">
            <b-form-input v-model="selectedItem.jobname" id="jobname" type="text" placeholder="Entre com seu cargo"></b-form-input>
          </b-form-group>
<!--
            <b-form-group
            label="Departamento"
            label-for="department"
            :label-cols="3"
            :horizontal="true">
            <b-form-select id="department"
              v-model="selectedItem.departmentid"
              :plain="true"
              :options="departmentddl"
              :value="[null,'c']">
            </b-form-select>
          </b-form-group>
-->
          <b-form-group label="Assinatura" 
            description=""
            label-for="signature"
            >
                <div slot="header">
                  Assinatura
                  <div class="card-header-actions">
                    <a href="https://github.com/surmon-china/vue-quill-editor" rel="noreferrer noopener" target="_blank" class="card-header-action">
                      <small class="text-muted">?</small>
                    </a>
                  </div>
                </div>
                <quill-editor v-model="selectedItem.signature" :content="selectedItem.signature" :options="editorMessageOptions"></quill-editor>
            </b-form-group>
          </b-card>
         
          <b-input-group class="mb-4">
              <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
          </b-input-group>
        
          <div slot="footer" class="text-right">
            <!--
            <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-toggle-on"></i><span>Habilitar</span></b-button>
            <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-toggle-on"></i><span>Desabilitar</span></b-button>
            -->
            <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="closeEditModal()"><i class="fa fa-window-close"></i><span>Cancelar</span></b-button>
            <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Usuário</span></b-button>
           
          </div>
                
        </div>
        </b-form>
  
      </b-modal>
  
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";

  import { Switch as cSwitch } from '@coreui/vue'
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  import MaskedInput from 'vue-text-mask'
  
  import VueQuillEditor from 'vue-quill-editor'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)

  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, username: '', name: '', alias: '', email: '', password: '', password2: '', description: '', st: 'A', _rowVariant: '', signature: '', phonepublic: true, phoneextpublic: true}
  
  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch,
      MaskedInput,
      VueQuillEditor
    },
    data: () => {
      return {
        editorMessageOptions: {
              placeholder: 'Entre com sua mensagem',
              readonly: false,
              height: 250
            },
        isBusy: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },

        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        editModal: false,
        dangerModal: false,
        filters: {
          key: '',
          status: 'A',
          type: 0
        },

        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
        currentItem: null,
        selectedItem: newItem,
        items: [          
        ],
        statusddl: [
          {
            text: '- Todos -',
            value: 0
          },
          {
            text: 'Ativo',
            value: 'A'
          },
          {
            text: 'Inativo',
            value: 'I'
          }
        ],
        typeddl: [
        /*
        {
          text: 'Selecione um departamento',
          value: null,
          disabled: true
        },
        */
        {
          text: 'Todos',
          value: 0
        },
        {
          text: 'Administração',
          value: '1'
        }, {
          text: 'Recursos Humanos',
          value: '2'
        }, {
          text: 'Compras',
          value: '3'
        }, {
          text: 'Informática/TI',
          value: '4'
        }],
        fields: [
          {key: 'show_details', label: "", thStyle: { width: "50px" }, tdClass: 'align-middle' },
          {key: 'avatar', label: "", thStyle: { width: "60px" }, tdClass: 'align-middle' },
          {key: 'id', label: 'Código', sortable: true, thStyle: { width: "15px" }, tdClass: 'text-center align-middle' },
          //{key: 'ean', label: 'EAN', sortable: true, tdClass: 'align-middle' },
          {key: 'typeName', label: 'Tipo de Produto', sortable: true, tdClass: 'align-middle' },
          {key: 'name', label: 'Produto', sortable: true, tdClass: 'align-middle' },
          {key: 'umCode', label: 'U/M', sortable: true, thStyle: { width: "40px" }, tdClass: 'text-center align-middle' },
          {key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" }, tdClass: 'text-center align-middle' }
        ],
        /*
        fields: [
            'show_details',
            { key: 'first_name', sortable: true }, 
            { key: 'last_name', sortable: true }
        ],
        items: [
          { isActive: true, age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
          { isActive: false, age: 21, first_name: 'Larsen', last_name: 'Shaw' },
          { isActive: false, age: 89, first_name: 'Geneva', last_name: 'Wilson', _showDetails: false },
          { isActive: true, age: 38, first_name: 'Jami', last_name: 'Carney' }
        ],
        */
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {      
      totalRows: function () { return this.getRowCount() },

      
      filteredItems() {
        try {
            return this.items.filter(item => {
              return (this.filters.key == '' || (
                  (item.name != null && item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  || (item.username != null && item.username.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  || (item.email != null && item.email.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)))
                  && (this.filters.status==0 || (this.filters.status == 'A' || this.filters.status == 'I') && item.st == this.filters.status )
                  && (this.filters.type==0 || item.typeId == this.filters.type )
            })
        }
        catch(e) {
            console.log(e)
            return this.items;
        }
      }
    },
    methods: {

      changeStatusBatch() {
        this.selected.forEach(el => this.changeStatus(el))
        this.dangerModal = false
        this.refreshData()
        
      },
      openBatchModal: function() {

        if(this.selected.length > 0) {
          this.dangerModal = true
        }
        else {
          toast ({
              type: VueNotifications.types.error,
              title: 'Alterar Usuários',
              message: 'Nenhum usuário selecionado',
              timeout: 5000
            })
        }

        
      }, 
      getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },
      submit() {
      },
      async changeStatus(currentUser) {
        var s = this;
        var userData;

        userData = {
            "id": currentUser.id,
            "st": currentUser.st,
            "currentUserId": this.$store.state.currentUser.id ,
            "currentUserSid": this.$store.state.currentUser.sid
        };
        
        await axios.post(
            this.$store.state.ws_url + "/product",
            userData
        ).then(
          function() {
            //s.currentItem.st = currentUser.st == "A" ? "I" : "A" ;
            //s.closeEditModal()

            toast ({
              type: VueNotifications.types.warn,
              title: 'Usuário',
              message: 'Status do usuário ' + currentUser.username + " alterado.",
              timeout: 5000
            })
          }
        ).catch(function (error) {
          console.log(error);

          toast ({
            type: VueNotifications.types.error,
            title: 'Produto',
            message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
            timeout: 5000
          })
          
        });        

      },

      async saveUser(currentUser) {

        //console.log('Salvando usuário')
        //console.log(currentUser);

        var s = this;
        var userData;

        if(currentUser.id != null && currentUser.id > 0) {
          userData = {
              "id": currentUser.id,
              "name": currentUser.name,
              "alias": currentUser.alias,
              "genderid": currentUser.genderid,
              "jobname": currentUser.jobname,
              "daten": currentUser.daten,
              "email": currentUser.email,
              "telephone": currentUser.telephone,
              "phonepublic": currentUser.phonepublic,
              "phoneext": currentUser.phoneext,
              "phoneextpublic": currentUser.phoneextpublic,
              "departmentid": currentUser.departmentid,
              "signature": currentUser.signature,
              "currentUserId": this.$store.state.currentUser.id ,
              "currentUserSid": this.$store.state.currentUser.sid
            };
        }
        else {
          userData = {
              "companyid": this.$store.state.config.companyId,
              "username": currentUser.username,
              "password": currentUser.password,
              "name": currentUser.name,
              "alias": currentUser.alias,
              "genderid": currentUser.genderid,
              "jobname": currentUser.jobname,
              "daten": currentUser.daten,
              "email": currentUser.email,
              "telephone": currentUser.telephone,
              "phonepublic": currentUser.phonepublic,
              "phoneext": currentUser.phoneext,
              "phoneextpublic": currentUser.phoneextpublic,
              "departmentid": currentUser.departmentid,
              "signature": currentUser.signature,
              "currentUserId": this.$store.state.currentUser.id ,
              "currentUserSid": this.$store.state.currentUser.sid
            };
        }

        await axios.post(
            this.$store.state.ws_url + "/system/user",
            userData
        ).then(function() {
            s.closeEditModal()
            s.refreshData();
          }
        ).catch(function (error) {
          console.log(error);

          toast ({
            type: VueNotifications.types.warn,
            title: 'Produto',
            message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
            timeout: 5000
          })

          //s.changePasswordErrorMessage = error.response.data.message;
        });
        

      },

      save() {
        
        let msgError = [];

        if(this.selectedItem.username.length <= 2)
          msgError.push("Nome do usuário");
        if(this.selectedItem.name.length <= 3)
          msgError.push("Nome completo");
        if(this.selectedItem.email.length <= 3)
          msgError.push("E-mail");

        // Alteração
        if(this.selectedItem != null && this.selectedItem.id > 0) {
          
        }
        // Inclusão
        else {
          if(this.selectedItem.password <= 3)
            msgError.push("Senha");
          if(this.selectedItem.password2 <= 3)
            msgError.push("Confirmar senha");
          if(msgError.length == 0) {
            if(this.selectedItem.password != this.selectedItem.password2)
               msgError.push("Senha e Confirmar senha diferentes. Verifique e tente novamente.");
          }
        }

        //console.log(msgError);
  
        if(msgError.length > 0) {
          let msgErrorExt = "Verifique os campos: ";
          let msgErrorSep = "";
          msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

          toast ({
            type: VueNotifications.types.error,
            title: 'Usuário',
            message: msgErrorExt,
            timeout: 5000
          })
        }
        else {
          this.saveUser(this.selectedItem);
        }
        
      },
      enableDisable() {
        //console.log('Habilitando/desabilitando usuário')
        this.changeStatus(this.selectedItem);
      },
      closeEditModal() {
        this.editModal = false;
      },
      openEditModal(item) {
        if(item == null) {
            this.selectedItem = newItem;      
        }
        else {
            this.selectedItem = JSON.parse(JSON.stringify(item));
        }
        this.editModal = true;
      },
      onRowSelected(items) {
        this.selected = items
        //console.log(items);
        //this.openEditModal(items[0])
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
        this.currentItem = item
        //  //console.log(item);
            
        if(!this.tableSelectable) {
            this.clearSelectedRows();
           
            this.openEditModal(item);
        }
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },
      toggleBusy() {
        this.isBusy = !this.isBusy
      },
      async typeDDL() {
          await axios.get(
            this.$store.state.ws_url + "/product/type/ddl"
          ).then(function(resp) {
            s.typeddl = resp.data.obj;
            s.typeddl.unshift({"value": "0", "text": "- Todos -"});
          }).catch(function(error) {
            console.log(error)
          })             
        
      },
      async refreshData() {
        var s = this;
        var currentUser = this.$store.state.currentUser;

        this.typeDDL();
        await axios.get(
            this.$store.state.ws_url + "/product?stockId=&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
          s.items = resp.data.obj;
        }).catch(function(error) {
          console.log(error)
        })
        
        this.isBusy = false;
      }
    },
    mounted: function() {
      this.isBusy = true;
      this.refreshData();
      
    }
  }
  </script>
  
<style scoped>

table#table-transition-example .flip-list-move {
  transition: transform 1s;
}

.circle-img {
  width: 50px;
  height: 50px;
  object-fit: cover;
  overflow: hidden;   
}

.ql-editor{
    min-height:200px;
}
</style>